import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "CETNo.",
            label: "CET No.",
            component: "text-field",
            width: "30%",
            type: "autocomplete",
            endpoint: "getHsnCodeMaster",
          },
          {
            name: "MRPStatus.",
            label: "MRP Status",
            component: "dropdown",
            width: "30%",
            options: [
              { label: "Y-Applicable", value: "Y-Applicable" },
              { label: "N-Not Applicable", value: "N-Not Applicable" },
              { label: "Q-Not Applicable(QTY > 25k)", value: "Q-Not Applicable(QTY > 25k)" },
              { label: "T-Not Applicable(Institutional Consumer)", value: "T-Not Applicable(Institutional Consumer)" },
              { label: "D-Not Applicable(Industrial Consumer)", value: "D-Not Applicable(Industrial Consumer)" },
            ],
          },
          
        ],
        row2: [
          {
            name: "SrNoinList",
            label: "SrNo in List.",
            component: "text-field",
          },
          {
            name: "MRPRs.",
            label: "MRP Rs.",
            component: "text-field"
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4},
          },
          {
            name: "MRPStatus.",
            label: "MRP Status",
            component: "dropdown",
            // width: "30%",
            options: [
              { label: "NOS", value: "NOS" },
            ],
          },
          {
            name: "Miscellaneousrate",
            actionText: "-Abt@",
            component: "typographytext",
            width: "25%",
            sx: { mt: 4  },
          },
          {
            name: "MRPRs313,.",
            label: "MRP Rs.",
            component: "text-field",
            placeholder: "0.00",
          },

        ],
        row3: [
          {
            name: "RSPNotification",
            label: "RSP Notification",
            component: "text-field",
            width: "30%",

          },
          {
            name: "SrNo",
            label: "Sr No",
            component: "text-field",
            width: "30%",

          },
          
        ],
        row4: [
          {
            name: "aidc",
            label: "AIDC.",
            component: "text-field",
          },
          {
            name: "aidcUnitValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              aidc: "notation",
            },
          },
          {
            name: "importitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "Miscellaneousrate",
            actionText: "% Exemption",
            width: "72%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1,  },
          },
          {
            name: "notaitiona",
            component: "text-field",
            // placeholder: "0.00",
          },
          {
            name: "value",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
          },
          {
            name: "value",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            // width: "15%",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row5: [
          {
            name: "HealthCess	",
            label: "Health Cess",
            component: "text-field",
          },
          {
            name: "healthnotationmaster",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              HealthCess: "notation",
            },
          },
          {
            name: "healthUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "healthaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "healthvalue",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "healthValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "healthquantity",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row6: [
          {
            name: "RoadInfra	",
            label: "Road & Infra. Cess",
            component: "text-field",
          },
          {
            name: "RoadInfranotationmaster",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              RoadInfra: "notation",
            },
          },
          {
            name: "RoadInfraUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "RoadInfraaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "RoadInfravalue",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",

          },
          {
            name: "RoadInfraValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "RoadInfraquantity",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row7: [
          {
            name: "SocialWelfare",
            label: "Social Welfare Surch.",
            component: "text-field",
          },
          {
            name: "SocialWelfarenotationmaster",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SocialWelfare: "notation",
            },
          },
          {
            name: "SocialWelfareUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "SocialWelfareaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row8: [
          {
            name: "EducationCess",
            label: "Education Cess",
            component: "text-field",
          },
          {
            name: "EducationCessnotationmaster",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              EducationCess: "notation",
            },
          },
          {
            name: "EducationCessUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "EducationCessaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row9: [
          {
            name: "SecHigherEdCess",
            label: "Sec & Higher Ed. Cess",
            component: "text-field",
          },
          {
            name: "SecHigherEdCessnotationmaster",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SecHigherEdCess: "notation",
            },
          },
          {
            name: "SecHigherEdCessUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "SecHigherEdCessaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row10: [
          {
            name: "NCD",
            label: "NCD",
            component: "text-field",
          },
          {
            name: "NCDUnitValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              NCD: "notation",
            },
          },
          {
            name: "NCDUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "NCDrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "NCDvalue",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",
          },
          {
            name: "NCDtValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "NCDquantity",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
          {
            name: "NCDvalue",
            component: "dropdown",
            options: [
              { label: "U.Sec.134", value: "U.Sec.134" },
              { label: "U.Sec.136", value: "U.Sec.136" },              
            ],
            defaultValue: "U.Sec.134",
          },
        ],
        row11: [
          {
            name: "AggregateDuty",
            label: "Aggregate Duty",
            component: "text-field",
          },
          {
            name: "AggregateDutymaster",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              AggregateDuty: "notation",
            },
          },
          {
            name: "AggregateDutyUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "AggregateDutyrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
        row12: [
          {
            name: "SafeguardDuty",
            label: "Safeguard Duty",
            component: "text-field",
          },
          {
            name: "SafeguardDutyUnitValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SafeguardDuty: "notation",
            },
          },
          {
            name: "SafeguardDutyUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "SafeguardDutyrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "SafeguardDutyvalue",
            component: "dropdown",
            options: [
              { label: "Plus", value: "Plus" },
              { label: "Minus", value: "Minus" },
              { label: "Higher", value: "Higher" },
              { label: "Lower", value: "Lower" },
            ],
            defaultValue: "Plus",
          },
          {
            name: "SafeguardDutytValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "SafeguardDutyquantity",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row13: [
          {
            name: "SAPTANotn.",
            label: "SAPTA Notn.",
            component: "text-field",
            width: "22%",
          },
          {
            name: "SAPTANotnDutyUnitValue",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getNotation",
            autofillTargets: {
              SAPTANotn: "notation",
            },
            width: "22%",
          },
          {
            name: "SAPTANotnDutyUnitValue",
            component: "text-field",
            placeholder: "0.00",
          },

        ],
        row14: [
          {
            name: "TariffValue",
            label: "Tariff Value",
            component: "text-field",
          },
          {
            name: "TariffValueUnitValue",
            component: "text-field",
          },
          {
            name: "TariffValuerate",
            actionText: "Qty",
            component: "typographytext",
            width: "2%",
            sx: { mt: 4   },
          },
          {
            name: "TariffValuetValue",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "TariffValuequantity",
            label: "Unit",
            component: "outlinebutton",
            sx: {
              mt: "32px",
            },
          },
          {
            name: "TamtfValuerate",
            actionText: "Amt",
            component: "typographytext",
            sx: { mt: 4   },
            width: "2%",

          },
          {
            name: "amtValuetValue",
            component: "text-field",
            endpoint: "getExchange",
            type: "autocomplete",

          },
          {
            name: "Tariff121Value",
            component: "text-field",
            placeholder: "0.00",
          },
          {
            name: "Tarifffskffserate",
            actionText: "/",
            component: "typographytext",
            sx: { mt: 4},
            width: "1%",

          },
          {
            name: "TariffValuequantity322",
            label: "Unit",
            component: "outlinebutton",
            sx: {
              mt: "32px",
            },
          },
        ],
      },
    },
  ],
};
